module.exports = __webpack_public_path__ + "img/7house04.a56957f1.jpg";